import { color } from "csx";

/** Greys */

export const brandGrey = color("#adadad");

export const brandMedGrey1 = color("#c5c5c5");
export const brandMedGrey2 = color("#808184");
export const brandLightGrey = color("#efefef");
export const brandBeige = color("#f6f5f3");
export const brandLightBeige = color("#fbfaf9");

/** Latrobe colors */

export const brandBlack = color("#000000");
export const brandRed = color("#e2231b");
export const brandBrightRed = color("#e2231b");
export const brandDarkRed = color("#a7281a");
export const white = color("#ffffff");
export const brandDarkBrown = color("#2d251a");
export const brandOrange = color("#e77622");

// export const brandNavyBlue = color("#01131f");
// export const brandYellow = color("#ffb527");
// export const neroGrey = color("#2a2929");
// export const brandTurquoise = color("#245f7d");
// export const brandGreen = color("#017069");
// export const black = color("#000000");

/**Other colors */
export const lightBlue = color("#1295ff");
export const niceBlue = color("rgb(191, 224, 241)");

/**Validation */

export const validationGreen = color("#28a745");
export const validationRed = color("#dc3545");

/**Faded Brand Colors */

export const fadedBrandBlack = color("#444242");
export const fadedBrandYellow = color("#ffc65a");
//For the blue forms
// export const fadedTurquoise = color(`#ecf1f4`);
// export const darkFadedTurquoise = color("#dce4ea");

export const grey1 = color("#fafafa");
export const grey2 = color("#eeeeee");
export const grey3 = color("#cccccc");
export const grey4 = color("#999999");
export const grey5 = color("#6C6C6C");
export const grey6 = color("#414141");
